import React from "react";
import { BiDollarCircle } from "react-icons/bi";
import { RiBookLine, RiMicroscopeLine } from "react-icons/ri";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "./home.scss";

import AOS from "aos";
import "aos/dist/aos.css";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";

function Home(props) {
	AOS.init({
		delay: 500,
		once: true
	});
	return (
		<div className="sec3">
			<div className="container">
				<div className="services">
					<div className="serviceHead">
						<h2 className="title" data-aos=""><br/>
							Explore Our Main Services
						</h2>
					</div>
					<div className="learnButton" data-aos="">
						<Link to="/laboratory/about-ggi-laboratory">
							<button >LEARN MORE</button>
						</Link>
					</div>
				</div>
			</div>
			<div className="servicesDiv container-fluid">
				<div className="container serviceCon">
					<div className="row">
						<div className="servicePro col-md-4">
							<div className="imageDiv">
								<img
									alt="Laboratory_Services_lspvxh.webp"
									className="lazy"
									data-src={
										"https://res.cloudinary.com/ggi/image/upload/v1637903452/Laboratory_Services_lspvxh.webp"
									}
									data-aos=""
								/>
								<div className="iconDiv" data-aos="">
									<RiMicroscopeLine />
								</div>
							</div>
							<div className="detail">
								<h6 className="small-title" data-aos="">
									Laboratory
								</h6>
								<h4 data-aos="">Certification of real Gemstones and Diamonds</h4>
								<p data-aos="">
									GGI is the first laboratory in Pakistan which offers the online verification of
									gemstones certificates.
								</p>
								<Link to="/laboratory/about-ggi-laboratory" className="readmore" data-aos="">
									READMORE
								</Link>
							</div>
						</div>
						<div className="servicePro col-md-4">
							<div className="imageDiv">
								<img
									alt="sl12_em1t40.webp"
									className="lazy"
									data-src={"https://res.cloudinary.com/ggi/image/upload/v1637903437/sl12_em1t40.webp"}
									data-aos=""
								/>
								<div className="iconDiv" data-aos="">
									<RiBookLine />
								</div>
							</div>
							<div className="detail">
								<h6 className="small-title" data-aos="">
									Education
								</h6>
								<h4 data-aos="">Developing an Industry</h4>
								<p data-aos="">
									To be a leading source of all knowledge and expertise in gems and jewellery.
								</p>
								<Link to="/gemological-education" className="readmore" data-aos="">
									READMORE
								</Link>
							</div>
						</div>
						<div className="servicePro col-md-4">
							<div className="imageDiv">
								<img
									alt="appraisalServiceSection2_dcvbip.webp"
									className="lazy"
									data-src={
										"https://res.cloudinary.com/ggi/image/upload/v1637903385/appraisalServiceSection2_dcvbip.webp"
									}
									data-aos=""
								/>
								<div className="iconDiv" data-aos="">
									<BiDollarCircle />
								</div>
							</div>
							<div className="detail">
								<h6 className="small-title" data-aos="">
									Lab Reports
								</h6>
								<h4 data-aos="">Gem and Jewellery Evaluation</h4>
								<p data-aos="">
									Assessment and valuation of loose gemstones, diamonds or stone studded jewellery
									has always been the most challenging task for any gemstone dealer or a jeweller.
								</p>
								<Link to="/laboratory/lab-reports" className="readmore" data-aos="">
									READMORE
								</Link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
const mapStateToProps = ({ store }) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Home));
